<template lang="">
    <div>
        <b-navbar toggleable="lg" type="dark" variant="primary" fixed="top">
            <b-navbar-brand href="#" @click="goback()">
                <b-icon icon="arrow-left"></b-icon> {{$route.query.desc}}
            </b-navbar-brand>
            <b-navbar-nav class="ml-auto">
    
                <b-nav-item>
                    <b-button-group>
                        <!-- <b-button variant="info" @click="onListItems">
                                                                <b-icon icon="list" aria-hidden="true" variant="light"></b-icon> ລາຍການ
                                                            </b-button> -->
    
                        <!-- <b-button variant="danger" @click="goback()">
                                                                <b-icon icon="x-lg" aria-hidden="true" variant="light"></b-icon> ປິດ
                                                            </b-button> -->
                    </b-button-group>
    
    
                </b-nav-item>
            </b-navbar-nav>
        </b-navbar>
    
        <div class="p-3">
    
            <!-- <form ref='uploadForm' id='uploadForm' @submit="submitForm" method='post' encType="multipart/form-data">
                <input ref="file" type="file" name="sampleFile" @change="onChangeFileUpload" />
                <input type='submit' value='Upload!' />
            </form>
     -->
    
            <b-form id="frm" name="frm" @submit="submitForm" ref="frm">
                <b-card>
    
                    <b-row>
                        <b-col>
    
                            <b-form-group label-cols="12" label-cols-lg="3" label="ຫົວຂໍ້ຂ່າວ:">
                                <b-form-input v-model="frm.header" required trim></b-form-input>
                            </b-form-group>
                        </b-col>
    
                    </b-row>
                    <b-row>
                        <b-col>
    
                            <b-form-group label-cols="12" label-cols-lg="3" label="ເນື້ອໃນ:">
                                <b-form-textarea id="textarea-rows" placeholder="ຂ່າວ......" rows="8" v-model="frm.content"></b-form-textarea>
                            </b-form-group>
                        </b-col>
    
                    </b-row>
    
                    <b-row>
                        <b-col>
    
                            <b-form-group label-cols="12" label-cols-lg="3" label="File:">
                                <!-- <b-form-file ref="file"  :state="Boolean(file1)"   v-model="file1"  @change="onChangeFileUpload" placeholder="Choose a file or drop it here..." drop-placeholder="Drop file here..."></b-form-file> -->
                                <b-form-file v-model="file" class="mt-3" plain></b-form-file>
                            </b-form-group>
                        </b-col>
    
                    </b-row>
                    <b-row>
                        <b-col>
                            
                            <b-button block type='submit' variant="outline-primary">ບັນທຶກ</b-button>
                        </b-col>
                    </b-row>
                </b-card>
    
    
            </b-form>
        </div>
   
    
    </div>
</template>

<script>
import axios from "axios";
export default {
    created() {
        let login = localStorage.getItem("Login");
        this.user = JSON.parse(login);
        this.frm.create_by=this.user.username
    },
    data() {
        return {
            file1:"",
            user: [],
            file: "",
            frm: {
                "img_banner": "",
                "header": "",
                "content": "",
                "attach": "",
                "create_by": "",
                "create_date": new Date().toISOString()
            }
        }
    },
    methods: {
        goback() {
            this.$router.go(-1);
        },
        submitForm(event) {
            event.preventDefault();

            const formData = new FormData();
            formData.append('file', this.file);
            formData.append('item', JSON.stringify( this.frm));
            //  const headers = { 'Content-Type': 'multipart/form-data' };
            // axios.post( this.$store.getters.getBaseUrl +'/upload', formData, { headers }).then((res) => {
            // //  res.data.files; // binary representation of the file
            // //  res.status; // HTTP status
            // console.log(res.data)
            // });

            axios
                .post(
                    this.$store.getters.getBaseUrl + "/upload",
                    formData, {
                        headers: {

                            'Authorization': 'Bearer ' + this.user.login_hash
                        }
                    }
                )
                .then((rep) => {
                    console.log(rep.data);
                    this.$router.go(-1);

                })

        },

        onChangeFileUpload() {
           
            this.file = this.$refs.file.files[0];
            

        }
    },

}
</script>

<style lang="">

</style>